import { useEffect, useState } from "react";

// One-shot "auto-open on first unlock" controller for a collapsible section.
//
// Contract (matches the per-section behavior the haklai calc view had
// inlined twice — once for property parts, once for expenses):
//   - Starts collapsed.
//   - The first time `isUnlocked` flips to true, expands the section and
//     records that the auto-open already happened.
//   - Subsequent lock → unlock transitions do NOT re-expand. If the user
//     collapsed the section manually after the initial auto-open, later
//     unlocks leave their choice intact.
//   - Re-locking never force-collapses the section; the parent decides
//     when to reset by unmounting.
//
// Returns a `[expanded, setExpanded]` tuple so callers can still drive the
// state imperatively from their toggle button.
const useAutoExpandOnUnlock = (isUnlocked) => {
  const [expanded, setExpanded] = useState(false);
  const [didAutoOpen, setDidAutoOpen] = useState(false);

  useEffect(() => {
    if (!isUnlocked || didAutoOpen) return;
    setExpanded(true);
    setDidAutoOpen(true);
  }, [didAutoOpen, isUnlocked]);

  return [expanded, setExpanded];
};

export default useAutoExpandOnUnlock;
